module.exports = __webpack_public_path__ + "img/handicapped_person_recruitment.4c777fb.webp";